import { v2 } from '@saucelabs/sl-module-builds';

export const NAMESPACE = 'flatBuildsVDCV2';

export const vdcBuildsV2Types = v2.buildsList.types.createVDCTypes(NAMESPACE);
